import React, {useEffect, useState} from 'react'
import ApplicationsData from "../../Datas/Applications.json"
import RippleButton from '../../../../components/Buttons/RippleButton'
import { BiFilter, BiSortAZ } from 'react-icons/bi'
import ico from "../../../assets/searchIcon/search.svg"
import Dropdown from "../../../../components/Dropdown/Dropdown"
import TrainingCard from '../../components/Card/TrainingCard'
import TrainingCardSkeleton from '../../components/Skeleton/TrainingCardSkeleton'
import {FormationDatas} from "../../../datas/FormationDatas"
import StudentCard from '../../components/Card/StudentCard'
import { Link } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import { END_POINT, USER_API_END_POINT } from '../../../../utils/constant'
import ImageWithFallback from '../../../components/ImageWithFallback'
import { formatInDate } from '../../../../components/DateTimeConverter/DateTimeConverter'
import axios from 'axios'
import { DropdownFilter, DropdownFilterItem } from '../../../../components/Form/DropdownFilter'
import * as XLSX from "xlsx";

const Students = () => {
const [students, setStudents] = useState([])
  const [training, setTraining] = useState(FormationDatas)
  const [tasks, setTasks] = useState([]);
  const [loading, setloading] = useState(false)
    const [openDropdown, setOpenDropdown] = useState(null);
      const [filters, setFilters] = useState({
        keyword: "",
        status: "",
        dateRange: "",
        sort: "",
      });

    useEffect(() => {
      // Fetch datas from JSON or API
      axios.get(USER_API_END_POINT+"/students/4")
        .then(response => {
          setStudents(response.data)
          console.log(response.data)
        })
        .catch(error => {
          console.error("Error fetching tasks datas:", error);
        })
    // setTasks(ApplicationsData)
    }, [])

    const toggleDropdown = (menu) => {
      setOpenDropdown(openDropdown === menu ? null : menu);
    };

        const handleSelect = (filterType, value) => {
          setFilters((prev) => ({ ...prev, [filterType]: value }));
        };

        const exportToExcel = () => {
          const ws = XLSX.utils.json_to_sheet(filteredCandidates);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Candidats");
          XLSX.writeFile(wb, "Liste_Candidats.xlsx");
        };

        const filteredCandidates = students
  .filter((student) =>
    student.nom.toLowerCase().includes(filters?.keyword?.toLowerCase())
  )
  .sort((a, b) => {
    if (!filters.sort) return 0;
    return filters.sort === "asc"
      ? a?.nom.localeCompare(b?.nom)
      : b?.nom.localeCompare(a?.nom);
  });

  return (
    <div className='layout-1'>
      <h1 className='font-semibold mb-6 text-start'>Liste des Etudiants</h1>
      <div className=" flex justify-between items-center mb-4 gap-x-4">
         <div className="relative flex items-center w-full md:w-96 h-10 rounded-lg   overflow-hidden border ">
          <div className="grid place-items-center h-full w-12 text-gray-300">
              <img src={ico} alt="serachbtn" />
          </div>
          <input
          className="peer h-full w-full outline-none text-sm text-gray-700 pr-2"
          type="text"
          id="search"
          placeholder="Mot clé..." 
          // onChange={(e)=>setFormData({...formData, keyword: e.target.value})}
          /> 
        </div>

        <div className="flex gap-2 ">
        {/* Filter button */}
        <DropdownFilter
        label={filters.sort || "Tri"}
        icon={<BiSortAZ />}
        isOpen={openDropdown === "sort"}
        onToggle={() => toggleDropdown("sort")}
      >
        <DropdownFilterItem
          text="Ordre croissant"
          onClick={() => handleSelect("sort", "Ordre croissant")}
        />
        <DropdownFilterItem
          text="Ordre décroissant"
          onClick={() => handleSelect("sort", "Ordre décroissant")}
        />
      </DropdownFilter>
        <button className="px-4 py-2 font-medium border text-[#24292F] hover:bg-primary-black hover:text-white rounded-md focus:outline-none text-sm flex gap-1 items-center justify-between">
        <BiFilter className='w-5 h-5'/>
        Filtrer
        </button>
        </div>
      </div>

      {/* Tableau */}
     {/* <div className="grid grid-cols-1 gap-4">

     
     {
     loading ?
      Array.from({ length: 6 }).map((_, index) => (
        <StudentCard key={index} />
      ))
      :
      training.map((item)=>{
        return ( 
          <StudentCard item={item}/>
          ) 
        }
      )
      }
     </div> */}

           {/* Tableau */}
           <div className="w-full pb-28 lg:w-[100%] xl:w-[900px] min-[1300px]:w-full overflow-x-auto">
        <table className="  text-sm whitespace-pre w-full ">
          <thead>
            <tr className="text-left text-sm bg-neutral-100  rounded-sm">
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Etudiant</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Dernière formation suivie</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm">Etat</th>
              <th className="pl-5 bg-neutral-100 py-2 rounded-sm ">Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredCandidates?.map((user, index) => (
              <tr key={user?.id} className=" border-b border-gray-100 rounded ">
                <td className=" py-3">
                  <div className="flex  ml-5 items-center gap-2 text-start ">
                    <input type="checkbox" name="g" id="" className='w-4 h-4 rounded-lg' />
                     <div className="flex items-center gap-2 p-1.5 w-fit hover:bg-neutral-100 rounded-lg cursor-pointer">
                        <ImageWithFallback src={END_POINT+"/storage"+user?.photo} alt="user1" defaultType='user' className='w-9 h-9 rounded-full' /> 
                        <div className="flex flex-col justify-between  w-fit mr-5 px-4">
                            <p className="text-base font-medium mr-2">{user?.nom}</p>
                            <div className="flex gap-2 text-xs">
                            {user?.email}
                            </div>
                        </div>
                     </div>                    
                  </div>
                </td>
                <td className="pl-  justify-start">
                  {user?.enrolments[0]?.training?.title}
                </td>
                <td className="pl-5">
                  <p className="text-sm leading-none  text-start flex gap-1 items-center text-primary-text">
                  {user?.enrolments[0]?.status}</p>
                </td>
                <td className="pl-5">
                    <div className="flex  items-center gap-2 text-start ">
                    {/* <RippleButton path={""+index} className='whitespace-nowrap w-40 bg-primary-green text-green-500 font-semibold hover:bg-primary-green/80' >Voir candidature</RippleButton> */}
                    {/* <DropdownStatusOpt  setDisplayModal={setStatusOption} key={index}/> */}
                      <Link
                      to={'/mira-formateur/etudiant/' + user?.id}
                        // ref={trigger}
                        // onClick={() => setDropdownOpen(!dropdownOpen)}
                          className="relative flex items-center justify-end gap-2 text-base text-neutral-500 font-medium text-dark bg-gray-50 border rounded-md p-2"
                      > 
                        <FaEye/>
                      </Link>

                    </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  )
}

export default Students